import { render, staticRenderFns } from "./SchemaTypes.vue?vue&type=template&id=6a53a66a&scoped=true"
import script from "./SchemaTypes.vue?vue&type=script&lang=js"
export * from "./SchemaTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a53a66a",
  null
  
)

export default component.exports